import { useEffect } from 'react'
import { router, useForm, usePage } from '@inertiajs/react'
import { Save } from 'lucide-react'
import { Button } from '@/components/ui/button'
import ProjectAgentAssignments, { type ProjectAgentInput } from '@/frontend/features/Fde/ProjectAgentAssignments'
import ProjectAgentProactivity from '@/frontend/features/Fde/ProjectAgentProactivity'
import type { ManagementProps, Project } from '@/frontend/features/Fde/types'
import type { SharedProps } from '@/frontend/types/inertia'

export default function ProjectTeamAgents({ props }: { props: ManagementProps }) {
  const copy = usePage<SharedProps>().props.navigationLabels.forge
  const project = props.project
  const saved = project?.agent_assignments || []
  const assignments: ProjectAgentInput[] = saved.map((item) => ({ digital_worker_id: item.agent.id, role_name: item.role_name, specialist_kind: item.specialist_kind, primary: item.primary }))
  const form = useForm({ project: { agent_assignments: assignments } })
  const pending = saved.some((item) => item.mcp_sync_status === 'pending' || item.repository_sync_status === 'pending')
  useEffect(() => {
    if (!pending || form.isDirty || form.processing) return
    const timer = window.setInterval(() => router.reload({ only: ['project'] }), 5000)
    return () => window.clearInterval(timer)
  }, [pending, form.isDirty, form.processing, project?.id])
  if (!project || !props.can_manage_access) return null
  return <form className="h-full overflow-y-auto" onSubmit={(event) => {
    event.preventDefault()
    form.patch(`/dashboard/discovery/projects/${project.id}?project_id=${project.id}&return_to=people&section_view=agents`, {
      preserveScroll: true,
      onSuccess: (page) => {
        const savedProject = page.props.project as Project
        const data = { project: { agent_assignments: savedProject.agent_assignments.map((item) => ({ digital_worker_id: item.agent.id, role_name: item.role_name, specialist_kind: item.specialist_kind, primary: item.primary })) } }
        form.setDefaults(data)
        form.setData(data)
      },
    })
  }}>
    <header className="flex items-center justify-between gap-4 border-b border-border px-6 py-5"><div><h1 className="text-xl font-semibold">{copy.agents}</h1><p className="mt-1 max-w-2xl text-xs text-muted-foreground">{copy.agents_description}</p></div><Button size="sm" disabled={!form.isDirty || form.processing}><Save />{props.copy.common.save}</Button></header>
    <div className="mx-auto max-w-4xl px-6 py-8">{Object.values(form.errors)[0] && <p role="alert" className="mb-4 text-sm text-destructive">{Object.values(form.errors)[0]}</p>}<ProjectAgentAssignments variant="page" agents={props.agents} assignments={form.data.project.agent_assignments} savedAssignments={saved} copy={props.copy} onChange={(next) => form.setData('project', { agent_assignments: next })} />
      {project.proactivity_copy && <ProjectAgentProactivity projectId={project.id} assignments={saved} copy={project.proactivity_copy} disabled={form.isDirty || form.processing} />}
    </div>
  </form>
}
